import React from "react";

export default function Loader() {

    return (
        <div className="loader-box">
            <img
                className="loader"
                alt="Loading..."
                src="../_SharedComponents/Assets/Icons/loader.gif"
            />
        </div>
    )
}

